// Modules
import React from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";
// Styles
import "./Summary.sass";
// Services
import ReservationService from "Services/reservation.service";
import { ScreenType } from "../../../Constants";

// Interfaces
import { ContractUsage, WaitlistAYPResult } from "Interfaces/AYPResultInterface";
import ContractToolTip from "Interfaces/ContractToolTipInterface";

// Components
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
//import { UsageDetails } from "./UsageDetails";
import { OwnerContract, OwnerShipDetails } from "Interfaces/OwnerInterface";
import MvContractToolTip from "Generic/ToolTip/MvContractToolTip";
import { Position } from "Generic/ToolTip/ToolTip";
import { RequestError } from "Interfaces/RequestError";
import { Confirmation } from "./Confirmation";
import { Review } from "./Review";
import { WaitlistCreateResultData } from "Interfaces/CreateWaitlist";

type Props = {
    token: string;
    lang: string;
    resId: number;
    waitListId?: number;
    setScreenType(screenType: ScreenType): void;
    screenType?: string;
    apiTimeout: string;
};

// key is preference code
export type SelectedPreferenceOptions = {
    [key: string]: string|string[]; 
};

type SummaryState = {
    appliedPointContracts: ContractUsage[]|null;
    contractToolTips: ContractToolTip[];
}

const InitState: SummaryState = {
    appliedPointContracts: null,
    contractToolTips: [],
};

class Summary extends React.Component<Props, SummaryState> {
    reservationService: ReservationService;
    _isMounted: boolean;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.reservationService = new ReservationService();
        this._isMounted = false;
    }

    componentDidMount() {
      this._isMounted = true;
      if(this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW) {
        let waitlistIdNum: number = this.props.waitListId || 0;
        this.reservationService.getWaitListInformation(waitlistIdNum)
          .then((waitListResult: any) => {
            sessionStorage.write("WAITLIST_RESPONSE", JSON.stringify(waitListResult));
            const appliedPointContracts: ContractUsage[] = waitListResult.pointsUsage;
            this.setState({appliedPointContracts}, () => {
              this.fetchContactTooltips(appliedPointContracts);
            });
          });
      }
      else {
        //If this is reservation flow
        const appliedPointContracts: ContractUsage[] = JSON.parse(sessionStorage.read(ReservationService.APPLIED_POINTS)) || [];

        this.setState({appliedPointContracts} , () => {
          this.fetchContactTooltips(appliedPointContracts);
      });
      }
    }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

    /**
   * Gets and stores the contract tooltip data for all contracts
   */
  fetchContactTooltips(contracts: ContractUsage[]) {
    return new Promise((resolve, reject) => {
        // get a unique list of contract Ids
        const contractList: any = new Set(contracts.map(usages => usages.contractId));

      // get the contracts' data
      this.reservationService.getOwnerContracts(contractList)
        .then((ownerContracts: OwnerContract[]) => {

          // build the ContractToolTip[]
          let contractToolTips: ContractToolTip[] = [];
          ownerContracts.map(contract => {
            // convert OwnerContract to ContractToolTip
            let tempContractToolTip = this.convertOCtoCTT(contract);
            // get the tooltip jsx
            tempContractToolTip.toolTip = this.getContractToolTipJSX(tempContractToolTip);
            contractToolTips.push(tempContractToolTip);
          });

          if (this._isMounted) {
            this.setState({
              contractToolTips
            });
          }
          resolve();
        })
        .catch((error: RequestError) => {
          reject(error);
        });
    });
  }

    /**
   * Converts the contract info into a ContracToolTip
   */
  getContractToolTipJSX(contractToolTip: ContractToolTip): any {
    const contractId = contractToolTip.contractId;
    const key = contractId + contractToolTip.startDate + contractToolTip.endDate + (contractToolTip.points ? contractToolTip.points.toString() : '');
    const contractIdStyle = <p key={key} className="contract-id mv-print-link" aria-label={contractId}>{contractId}</p>

    return <MvContractToolTip contract={contractToolTip} position={Position.RIGHT}>
            {contractIdStyle}
          </MvContractToolTip>;
  }

  convertOCtoCTT(oc: OwnerContract): ContractToolTip {
    // the AYP table is still returning mock data? that will be returning real
    //  data this sprint by Rama - done by tomorrow perhaps
    // getting CORS error
    return {
        id: oc.id, 
        contractId: oc.contractNumber, 
        contractType: oc.contractType,
        // hard code to points for now
        // the service is not providing this field 
        // it is also not returning any weeks data
        typeName: "points", 
        startDate: oc.contractStartDate,
        endDate: oc.contractEndDate,
        // this field is missing from the service
        // it is being looked into
        // so for now, just show the start date's year
        usageYear: oc.contractStartDate,
        points: oc.contractPoints,
        ownershipDetails: oc.ownershipDetails ? oc.ownershipDetails : {} as OwnerShipDetails //CE2RT1C-899 - 7. add ownersheip details to contract tool tip
      };
  }

    handleContractsSort = (sortedContracts: ContractUsage[]) => {
        this.setState({appliedPointContracts: sortedContracts});
    }

    getWaitlistResultDetails(result: any): WaitlistCreateResultData {
      const res: WaitlistCreateResultData = {
        summary: {
          primaryGuest: result.summary.primaryGuest,
          terms: result.summary.terms,
          reservationDetails: result.summary.reservationDetails,
          preferences: result.summary.preferences,
          extras: result.summary.extras
        },
        pointsUsage: result.pointsUsage,
        usageRequiredByDay: result.usageRequiredByDay,
        waitlistReservationId: result.waitlistReservationId,
        primaryGuest: result.primaryGuest,
        additionalGuests: result.additionalGuests,
        additionalEmails: result.additionalEmails,
        selectedStayPreferences: result.selectedStayPreferences,
        sessionId: result.sessionId,
        priority: result.priority,
        expirationLeadTime: result.expirationLeadTime,
        waitlistRooms: result.waitlistRooms,
        affordableRoom: result.affordableRoom,
        wfeWaitlistReservationID: result.wfeWaitlistReservationID,
        wfeWaitlistReservationConfirmationNumber: result.wfeWaitlistReservationConfirmationNumber,
        transactionDate: result.transactionDate,
        transactionTime: result.transactionTime,
        ownerId: result.ownerID
      }

      return res;
    }

    render() {
        const { localize } = this.context;
        
        const bookingInfo = JSON.parse(sessionStorage.read(ReservationService.BOOKED_RESERVATION));

        console.log(typeof bookingInfo);

        let content;

        //TODO: Revert this back to below commented out code
        //TODO: Remove the waitlist creation from session storage
        if(bookingInfo) {
          //TODO: see why we have to use the keyword waitlists to access the object
          //TODO: handle this for reservation flow
          const waitlistResult: WaitlistCreateResultData = bookingInfo;
          const waitlistReservationId: number = bookingInfo.wfeWaitlistReservationID;
          content = 
              <Confirmation
                bookingInfo={bookingInfo}
                waitlistBookingInfo={waitlistResult}
                setScreenType={this.props.setScreenType}
                appliedPointContracts={this.state.appliedPointContracts}
                contractToolTips={this.state.contractToolTips}
                handleContractsSort={this.handleContractsSort}
                screenType={this.props.screenType}
                waitlistResevrationId={waitlistReservationId}
                waitlistRooms={waitlistResult.waitlistRooms}
                apiTimeout = {this.props.apiTimeout}
              />
        } else {
          content = 
              <Review
                resId={this.props.resId}
                waitListId={this.props.waitListId}
                setScreenType={this.props.setScreenType}
                appliedPointContracts={this.state.appliedPointContracts}
                contractToolTips={this.state.contractToolTips}
                handleContractsSort={this.handleContractsSort}
                screenType={this.props.screenType}
                apiTimeout = {this.props.apiTimeout}
              />
        }

        // let content = (
        //     <Review
        //         resId={this.props.resId}
        //         waitListId={this.props.waitListId}
        //         setScreenType={this.props.setScreenType}
        //         appliedPointContracts={this.state.appliedPointContracts}
        //         contractToolTips={this.state.contractToolTips}
        //         handleContractsSort={this.handleContractsSort}
        //         screenType={this.props.screenType}
        //     />
        // );

        // if (bookingInfo) {
        //     content = 
        //       <Confirmation
        //         bookingInfo={bookingInfo}
        //         setScreenType={this.props.setScreenType}
        //         appliedPointContracts={this.state.appliedPointContracts}
        //         contractToolTips={this.state.contractToolTips}
        //         handleContractsSort={this.handleContractsSort}
        //         screenType={this.props.screenType}
        //       />
        // }

        return (
            <div className='summary-review-page'>
               {content} 
            </div>
        );
    }
}

Summary.contextType = LocalizationContext;

export default Summary;
